<template>
    <div class="flex flex-col gap-10">
        <div class="flex flex-col gap-2">
            <h1 class="text-xl font-semibold primary_color truncate">
                Add WhatsApp {{ selectedVendor?.toUpperCase() || 'MSG91' }} account credentials
            </h1>
            <p class="text-sm font-normal leading-[17px] secondary_color line-clamp-1">
                Enter your API key and required fields to get started.    
            </p>
        </div>

        <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1">
                    <label class="text-[13px] font-normal leading-[13px] secondary_color">API Key</label>
                    <a-tooltip
                        placement="top"
                        color="var(--tooltip-bg)"
                        :title="'API Key information'"
                    >
                        <ThemeImage class="size-3" :icon="imageNames.INFO_GREY" alt="info_icon" />
                    </a-tooltip>
                </div>
                <a-input
                    v-model:value="apiKey"
                    placeholder="200008784534289tyfu984ewghy984"
                    class="input_medium"
                    @input="handleInput"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";

const props = defineProps({
    selectedVendor: {
        type: String,
        default: null,
    },
    vendorData: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(["update:vendorData"]);

const apiKey = ref(props.vendorData?.apiKey || "");

watch(() => props.vendorData, (newValue) => {
    if (newValue?.apiKey) {
        apiKey.value = newValue.apiKey;
    }
}, { deep: true });

const handleInput = () => {
    emit("update:vendorData", {
        ...props.vendorData,
        apiKey: apiKey.value,
    });
};

// Expose method for parent component validation
const validateBeforeNext = () => {
    if (!apiKey.value || apiKey.value.trim() === "") {
        return false;
    }
    return true;
};

defineExpose({
    validateBeforeNext,
    getVendorData: () => ({
        ...props.vendorData,
        apiKey: apiKey.value,
    }),
});
</script>


